import { useEffect, useState } from "react"
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import { IListBase } from "../interfaces/IListado";
import { GetListBase } from "../services/list";



const useListBase = () => {

    // States
    const [listbase, setListBase] = useState<IListBase[]>([]);
    const [loadingListBase, setLoadingListBase] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetListBase();
    }, [])

    // Handles
    const handleGetListBase = () => {
        setLoadingListBase(true)
        tryCatch(() => {
            GetListBase()
                .then((response) => {
                    setListBase(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingListBase(false));
        })
    }

    return {
        listbase,
        loadingListBase
    }
}


export default useListBase;